document.addEventListener("DOMContentLoaded", function () {
  /* --------------------------------------
   * Mobile drawer logic
   * ------------------------------------ */
  const mobileElements = {
    toggleButton: document.querySelector(".mc-navbar__mobile-toggle"),
    closeButton: document.querySelector(".mc-navbar__mobile-close"),
    drawer: document.querySelector(".mc-navbar__mobile-drawer"),
    overlay: document.querySelector(".mc-navbar__mobile-overlay"),
    drawerContent: document.querySelector(".mc-navbar__mobile-content"),
  };

  const hasMobile =
    mobileElements.toggleButton &&
    mobileElements.drawer &&
    mobileElements.drawerContent;

  if (hasMobile) {
    function openDrawer() {
      mobileElements.drawer.classList.remove("hidden");
      mobileElements.drawer.offsetHeight;

      requestAnimationFrame(() => {
        mobileElements.drawer.classList.add("is-open");
        mobileElements.drawer.setAttribute("aria-hidden", "false");
        mobileElements.toggleButton.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
      });

      setTimeout(() => {
        if (mobileElements.closeButton) mobileElements.closeButton.focus();
      }, 300);
    }

    function closeDrawer() {
      mobileElements.drawer.classList.remove("is-open");
      mobileElements.drawer.setAttribute("aria-hidden", "true");
      mobileElements.toggleButton.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";

      setTimeout(() => {
        mobileElements.drawer.classList.add("hidden");
      }, 650);

      if (mobileElements.toggleButton) mobileElements.toggleButton.focus();
    }

    mobileElements.toggleButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });

    if (mobileElements.closeButton) {
      mobileElements.closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    }

    if (mobileElements.overlay) {
      mobileElements.overlay.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    }

    document.addEventListener("click", (e) => {
      if (mobileElements.drawer?.classList.contains("is-open")) {
        if (
          !mobileElements.drawerContent?.contains(e.target) &&
          !mobileElements.toggleButton.contains(e.target)
        ) {
          closeDrawer();
        }
      }
    });

    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        mobileElements.drawer?.classList.contains("is-open")
      ) {
        closeDrawer();
      }
    });
  }

  /* --------------------------------------
   * Desktop submenu auto-flip to avoid viewport overflow
   * ------------------------------------ */
  const desktopMQ = window.matchMedia("(min-width: 960px)");

  function measureAndFlip(submenuEl, parentItem) {
    if (!submenuEl) return;

    submenuEl.classList.remove("mc-navbar__menu--flip");
    parentItem?.classList.remove("mc-navbar__menu-item--flip");

    const prevDisplay = submenuEl.style.display;
    const prevVisibility = submenuEl.style.visibility;
    const prevOpacity = submenuEl.style.opacity;

    submenuEl.style.visibility = "hidden";
    submenuEl.style.opacity = "0";
    submenuEl.style.display = "block";

    const rect = submenuEl.getBoundingClientRect();

    submenuEl.style.display = prevDisplay || "";
    submenuEl.style.visibility = prevVisibility || "";
    submenuEl.style.opacity = prevOpacity || "";

    const overflowRight = rect.right > window.innerWidth - 16;
    const overflowLeft = rect.left < 16;

    if (overflowRight && !overflowLeft) {
      submenuEl.classList.add("mc-navbar__menu--flip");
      parentItem?.classList.add("mc-navbar__menu-item--flip");
    }
  }

  function setupDesktopFlips() {
    if (!desktopMQ.matches) return;

    const secondaryItems = document.querySelectorAll(
      ".mc-navbar__menu-item--secondary"
    );
    secondaryItems.forEach((item) => {
      const submenu = item.querySelector(".mc-navbar__menu-tertiary");
      if (!submenu) return;
      item.addEventListener("mouseenter", () => measureAndFlip(submenu, item));
    });

    const tertiaryItems = document.querySelectorAll(
      ".mc-navbar__menu-item--tertiary"
    );
    tertiaryItems.forEach((item) => {
      const submenu = item.querySelector(".mc-navbar__menu-quaternary");
      if (!submenu) return;
      item.addEventListener("mouseenter", () => measureAndFlip(submenu, item));
    });
  }

  setupDesktopFlips();
  desktopMQ.addEventListener("change", setupDesktopFlips);
});
